// web/src/api/users/UsersAPI.ts
import {
  ChangePasswordPayload,
  CreateUserPayload,
  PhoneTypeListTypes,
  ResetPasswordPayload,
  RolesListTypes,
  UpdateUserPayload,
  UserDetailsTypes,
} from '@/pages/Profile/store/types';
import {
  AllUsersTypes,
  ApproveRejectUserPayloadTypes,
  PendingApprovalTypes,
  UserReviewersTypes,
} from '@/pages/users/store/types';
import { AxiosInstance, AxiosResponse } from 'axios';

export default class UsersAPI {
  client: AxiosInstance;
  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getAllUsers(): Promise<AxiosResponse<{ data: AllUsersTypes[] }>> {
    return this.client.get<{ data: AllUsersTypes[] }>('/v2/user/');
  }

  async getRolesList(): Promise<AxiosResponse<{ data: RolesListTypes[] }>> {
    return this.client.get<{ data: RolesListTypes[] }>('/v2/user/role/');
  }

  async getUserDetails(
    id: string,
  ): Promise<AxiosResponse<{ data: UserDetailsTypes }>> {
    return this.client.get<{ data: UserDetailsTypes }>(`/v2/user/${id}/`);
  }

  async getPhoneTypeList(): Promise<
    AxiosResponse<{ data: PhoneTypeListTypes[] }>
  > {
    return this.client.get<{ data: PhoneTypeListTypes[] }>(
      '/v2/user/phone/type/',
    );
  }

  async blockUser({ id }: { id: string }): Promise<AxiosResponse<void>> {
    return this.client.put<void>(`/v2/user/${id}/block/`);
  }

  async unBlockUser({ id }: { id: string }): Promise<AxiosResponse<void>> {
    return this.client.put<void>(`/v2/user/${id}/enable/`);
  }

  async resubmitUser(id: string): Promise<AxiosResponse<void>> {
    return this.client.post<void>(`/v2/user/${id}/resubmit/`);
  }

  async updateUserDetails({
    id,
    data,
  }: UpdateUserPayload): Promise<AxiosResponse<{ data: UpdateUserPayload }>> {
    return this.client.put<{ data: UpdateUserPayload }>(
      `/v2/user/${id}/`,
      data,
    );
  }

  async approveUsers({
    id,
    data,
  }: ApproveRejectUserPayloadTypes): Promise<
    AxiosResponse<{ data: ApproveRejectUserPayloadTypes }>
  > {
    return this.client.post<{ data: ApproveRejectUserPayloadTypes }>(
      `/v2/user/review-request/${id}/approve/`,
      data,
    );
  }

  async rejectUsers({
    id,
    data,
  }: ApproveRejectUserPayloadTypes): Promise<
    AxiosResponse<{ data: ApproveRejectUserPayloadTypes }>
  > {
    return this.client.post<{ data: ApproveRejectUserPayloadTypes }>(
      `/v2/user/review-request/${id}/reject/`,
      data,
    );
  }

  async getPendingApprovals(): Promise<
    AxiosResponse<{ data: PendingApprovalTypes[] }>
  > {
    return this.client.get<{ data: PendingApprovalTypes[] }>(
      '/v2/user/?pendingApproval=true',
    );
  }

  async getUserReviewers(): Promise<
    AxiosResponse<{ data: UserReviewersTypes[] }>
  > {
    return this.client.get<{ data: UserReviewersTypes[] }>(
      '/v2/user/?reviewers=true',
    );
  }

  async createUsers({
    data,
  }: CreateUserPayload): Promise<AxiosResponse<{ data: CreateUserPayload }>> {
    return this.client.post<{ data: UpdateUserPayload }>('/v2/user/', data);
  }

  async resetPassword({
    user_id,
  }: ResetPasswordPayload): Promise<
    AxiosResponse<{ data: ResetPasswordPayload }>
  > {
    const body = {
      user_id,
    };
    return this.client.post<{ data: ResetPasswordPayload }>(
      '/v2/user/reset-password/',
      body,
    );
  }

  async changePasswords(
    body: ChangePasswordPayload,
  ): Promise<AxiosResponse<{ data: ChangePasswordPayload }>> {
    return this.client.post<{ data: ChangePasswordPayload }>(
      '/v2/user/change-password/',
      body,
    );
  }
}
